<div class="headless">
  <p-toast baseZIndex="1000" key="notification" position="top-right"></p-toast>
  <app-title-bar *ngIf="electronService.isElectronApp" [showSettings]="false" [headlessMode]="true"></app-title-bar>
  <app-tab [tab]="headlessTab"></app-tab>
</div>
<app-snippet-popup></app-snippet-popup>
